import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StyledToolTipModal = styled.div` ${ () => `
  padding: 56px 30px;

  .tooltip__close_cta {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    color: #001E50;
    top: 18px;
    right: 18px;
    cursor: pointer;
  }

  .tooltip__title {
    margin-bottom: 20px;
  }

  @media (min-width: ${Breakpoints.b960}px) {
    padding: 56px 80px;

    .tooltip__title {
        margin-bottom: 24px;
    }
  }
`}`;
